import { render, staticRenderFns } from "./PrepostHomeDashColumn.vue?vue&type=template&id=faab374e&scoped=true"
import script from "./PrepostHomeDashColumn.vue?vue&type=script&lang=js"
export * from "./PrepostHomeDashColumn.vue?vue&type=script&lang=js"
import style0 from "./PrepostHomeDashColumn.vue?vue&type=style&index=0&id=faab374e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faab374e",
  null
  
)

export default component.exports